import HttpService from '../../infra/http/AxiosConfig'
import CancelablePromise from '../../functions/CancelablePromise';

const resource = 'usuarios'

const formToApiRequest = value => {
  const payload = ({
    id: value.id,
    email: value.email,
    foto: value.photo ? value.photo.split(',')[1] : null,
    nome: value.name,
    senha: value.password,
    telefone: value.phone,
    idRevenda: value.idRevenda,
    menu: value.menu
  })
  return value.heitherOperationParameter
    ? payload
    : {
      ...payload,
      podeAceitar: value.canAccept,
      podeRejeitar: value.canReject,
      podeCancelar: value.canCancel,
    }
}

const apiRequestToForm = user => {
  return ({
    id: user.id,
    email: user.email,
    photoUrl: user.imagem,
    name: user.nome,
    phone: user.telefone,
    password: "",
    menu: user.menu
  })
}

export const remove = id =>
  HttpService.AxiosClient.delete(`${resource}?id=${id}`)

export const post = value =>
  HttpService.AxiosClient.post(resource, formToApiRequest(value));

export const update = value =>
  HttpService.AxiosClient.put(resource, formToApiRequest(value))

export const get = (page, pageSize, filter) =>
  CancelablePromise(HttpService.AxiosClient.get(`${resource}\\${page}\\${pageSize}?filtro=${filter}`))

export const find = id =>
  new Promise(async (resolve, reject) => {
    try {
      const result = await HttpService.AxiosClient.get(`${resource}\\${id}`)
      const user = apiRequestToForm(result);
      user.id = id;
      resolve(user)
    } catch (error) {
      reject(error)
    }
  })

export const getMenus = id => HttpService.AxiosClient.get(`${resource}/${id}/menu`)

export const getTermsAndConditionsHTML = () => HttpService.AxiosClient.get(`${resource}/TermosCondicoes/html`)
